/**
 * Created by Ning Jiang on 2021-05-07.
 */

export class MathHelper {

    public static randomNumberInRange(min: number, max: number, decimals: number = 0): number {
        let randomNumber: number = min + (max - min) * Math.random();
        return Number(randomNumber.toFixed(decimals));
    }

    public static roundToDecimals(num: number, noOfDecimals: number): number {
        return Number((num).toFixed(noOfDecimals));
    }

    static degToRad(deg: number): number {
        return Math.PI / 180 * deg;
    }

    /**
     * Maps value x in range inStart -> inEnd to range outStart -> outEnd.
     *
     * @param x Value to map to new range. x is a value in the in range.
     * @param inStart Start value in in range.
     * @param inEnd End value in in range.
     * @param outStart Start value in out range.
     * @param outEnd   End value in out range.
     * @returns {number}
     */
    static map(x:number, inStart:number, inEnd:number, outStart:number, outEnd:number):number {
        return (x - inStart) * (outEnd - outStart) / (inEnd - inStart) + outStart;
    }
}